import LayoutProvider from '../LayoutProvider'

export default LayoutProvider
